import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from '../ui/Button';
import { Container } from '../ui/Container';
export function Navigation() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  return <nav className="sticky top-0 z-50 w-full border-b border-gray-200 bg-white/80 backdrop-blur-md" data-id="element-115">
      <Container data-id="element-116">
        <div className="flex h-16 items-center justify-between" data-id="element-117">
          {/* Logo */}
          <div className="flex-shrink-0" data-id="element-118">
            <Link to="/" className="flex items-center space-x-2" data-id="element-119">
              <img src="https://cdn.magicpatterns.com/uploads/rSLUSD121ZLtwvfij6sTqX/flowsense.png" alt="Flowsense" className="h-8 w-8" data-id="element-120" />
              <span className="text-xl font-bold text-gray-900" data-id="element-121">Flowsense</span>
            </Link>
          </div>

          {/* Desktop CTAs */}
          <div className="hidden md:block" data-id="element-122">
            <div className="flex items-center space-x-4" data-id="element-123">
              <a href="https://app.useflowsense.com/auth/login" className="text-sm font-medium text-gray-600 hover:text-gray-900" data-id="element-124">
                Sign In
              </a>
              <a href="https://app.useflowsense.com/auth/signup" data-id="element-125">
                <Button size="sm" noGradient data-id="element-126">
                  Signup Free
                </Button>
              </a>
            </div>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden" data-id="element-127">
            <button onClick={() => setIsOpen(!isOpen)} className="inline-flex items-center justify-center rounded-md p-2 text-gray-400 hover:bg-gray-100 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary" data-id="element-128">
              <span className="sr-only" data-id="element-129">Open main menu</span>
              {isOpen ? <X className="block h-6 w-6" aria-hidden="true" data-id="element-130" /> : <Menu className="block h-6 w-6" aria-hidden="true" data-id="element-131" />}
            </button>
          </div>
        </div>
      </Container>

      {/* Mobile menu */}
      {isOpen && <div className="md:hidden" data-id="element-132">
          <div className="border-t border-gray-200 pb-4 pt-4" data-id="element-133">
            <div className="flex flex-col space-y-3 px-4" data-id="element-134">
              <a href="https://app.useflowsense.com/auth/login" className="block text-base font-medium text-gray-600 hover:text-gray-900" data-id="element-135">
                Sign In
              </a>
              <a href="https://app.useflowsense.com/auth/signup" data-id="element-136">
                <Button className="w-full justify-center" noGradient data-id="element-137">
                  Signup Free
                </Button>
              </a>
            </div>
          </div>
        </div>}
    </nav>;
}